import { UISDK } from "@/ui-sdk";
import { parseHandles } from "../utils";

export default function handleDynamicText(element: HTMLElement, sdk: UISDK) {
  const val = element.getAttribute("data-helium-dynamic-text-items");
  if (!val) {
    console.log("No valid 'data-helium-dynamic-text-items*' attribute found.");
    return;
  }

  const texts = parseHandles(val);

  const h2Element = element.querySelector("h2");

  if (h2Element) {
    h2Element.innerHTML = sdk.renderDynamicText(texts);
    console.log("Updated h2 text:", h2Element.innerHTML);
  } else {
    console.log("No h2 element found.");
  }
}
